<template>
  <div class="container">
    <div class="spinner-box" v-if="isLoading">
      <span class="spinner" />
    </div>
    <div v-else>
      <div class="status-box max-w-3xl">
        <img
          class="conversa-logo"
          src="https://cdn.intertelconversa.com/logo_conversa.svg"
        />
        <div v-if="confirmation_code">
          <p class="status-title">
            Confirmación de eliminación de datos
          </p>
          <p class="status-message">
            Te confirmamos que tu solicitud de eliminación de datos con número
            de Folio: <b>{{ confirmation_code }}</b> ha sido procesada y
            completada el <b>{{ deletion_date }}</b> a las
            <b>{{ deletion_time }}</b
            >. Tus datos han sido eliminados de forma segura de nuestros
            sistemas de conformidad a las políticas de privacidad y uso de datos
            de META.
          </p>
          <p class="status-message">
            Gracias por tu confianza.
          </p>
          <p class="status-message atte-message">
            Atentamente:<br />
            El equipo de Intertel Conversa.
          </p>
        </div>
        <div v-else>
          <p class="status-title">
            El número de folio ingresado no es válido. Si necesitas ayuda,
            contáctanos.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const dayjs = require('dayjs');
const esLocale = require('dayjs/locale/es');
dayjs.locale('es');

export default {
  data() {
    return {
      isLoading: true,
      confirmation_code: '',
      deletion_date: '',
      deletion_time: '',
    };
  },
  props: {
    id: { type: String, default: '' },
  },
  async created() {
    try {
      const response = await fetch(`/userdata/deletion?id=${this.id}`);
      const data = await response.json();
      if (data.confirmation_code) {
        this.confirmation_code = data.confirmation_code;
        this.deletion_date = dayjs(data.created_at).format(
          'DD [de] MMMM [de] YYYY'
        );
        this.deletion_time = dayjs(data.created_at).format('hh:mm A');
      }
    } catch (error) {
      console.error('Error:', error);
    }
    this.isLoading = false;
  },
};
</script>

<style scoped lang="scss">
@import '~dashboard/assets/scss/variables';
@import '~dashboard/assets/scss/mixins.scss';

.container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100vw;
  background-image: url('/assets/images/conversa2/bg-deletion.svg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.status-box {
  width: 816px;
  border-radius: $space-normal;
  padding: $space-larger;
  @include background-white;
  @include conversa2-border-normal;
}

.spinner-box {
  display: flex;
  justify-content: center;
}

.conversa-logo {
  width: 216px;
  height: 48px;
  margin-bottom: $space-medium;
}

.status-title {
  font-size: $font-size-tera;
  color: $conversa2-blue-700-color;
  margin-bottom: $space-medium;
  line-height: 56px;
}

.status-message {
  color: $conversa2-neutral-800-color;
  font-size: $font-size-medium;
  margin-bottom: $space-medium;
}

.atte-message {
  margin-bottom: $zero;
}

div.status-box b {
  color: $conversa2-blue-700-color;
  font-weight: $font-weight-bold;
}
</style>
